import { ButtonBase, Stack, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { AdvisorContactLineContent } from "web_myplann/Advisor/Components/AdvisorContactLineContent";

type Props = {
	icon: LucideIcon;
	text: string;
	href?: string;
	ariaLabel?: string;
	compact?: boolean;
};

export const AdvisorContactLine: FC<Props> = ({
	icon,
	text,
	href,
	ariaLabel,
	compact,
}) => {
	const theme = useTheme();

	if (href) {
		return (
			<ButtonBase
				component="a"
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				aria-label={ariaLabel}
				sx={{
					gap: theme.spacingTokens.sm,
					minHeight: compact ? 24 : undefined,
					maxWidth: "100%",
					borderRadius: theme.shape.borderRadius,
					textAlign: "left",
					textDecoration: "none",
				}}
			>
				<AdvisorContactLineContent
					icon={icon}
					text={text}
					isLink
					compact={compact}
				/>
			</ButtonBase>
		);
	}

	return (
		<Stack direction="row" alignItems="center" gap={theme.spacingTokens.sm}>
			<AdvisorContactLineContent
				icon={icon}
				text={text}
				isLink={false}
				compact={compact}
			/>
		</Stack>
	);
};
